import { api } from "@/lib/api";

const UTM_KEY = "c2g_utm";
const SID_KEY = "c2g_sid";
const CONSENT_KEY = "c2g_cookie_consent";

const sid = (() => {
  let v = localStorage.getItem(SID_KEY);
  if (!v) {
    v = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(SID_KEY, v);
  }
  return v;
})();

const params = new URLSearchParams(window.location.search);
if (params.get("utm_source") || params.get("utm_campaign") || params.get("fbclid")) {
  const utm = {
    utm_source: params.get("utm_source") || (params.get("fbclid") ? "facebook" : null),
    utm_medium: params.get("utm_medium"),
    utm_campaign: params.get("utm_campaign"),
  };
  if (!localStorage.getItem(UTM_KEY)) localStorage.setItem(UTM_KEY, JSON.stringify(utm));
}

const PIXEL_EVENTS = { lp_view: "ViewContent", lp_cta: "InitiateCheckout", quiz_complete: "Lead", register: "CompleteRegistration", trial_start: "StartTrial" };

export const getConsent = () => localStorage.getItem(CONSENT_KEY);

let pixelId = null;
export const pixelConfigured = api.get("/site-config").then(({ data }) => {
  pixelId = data.meta_pixel_id || null;
  if (pixelId && getConsent() === "yes") loadPixel();
  return !!pixelId;
}).catch(() => false);

function loadPixel() {
  if (!pixelId || window.fbq) return;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,"script","https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
}

export function setConsent(yes) {
  localStorage.setItem(CONSENT_KEY, yes ? "yes" : "no");
  if (yes) loadPixel();
}

export function track(event) {
  const utm = JSON.parse(localStorage.getItem(UTM_KEY) || "{}");
  api.post("/track", { event, sid, path: window.location.pathname, ...utm }).catch(() => {});
  if (window.fbq && PIXEL_EVENTS[event]) window.fbq("track", PIXEL_EVENTS[event]);
}
